import React, { useState } from 'react';
import { Box, Typography, Paper, Button, CircularProgress } from '@mui/material';
import { useAuth } from 'contexts/AuthContext';
import { useLoading } from 'App';

const HomePage: React.FC = () => {
  const { auth } = useAuth();
  const { setIsLoading } = useLoading();
  const [loading, setLoading] = useState(false);

  // Function to demonstrate the loading functionality with a fake API call
  const fetchSampleData = async () => {
    try {
      // Local loading state for button
      setLoading(true);
      
      // Global loading state for loading bar
      setIsLoading(true);
      
      console.log('Starting fake API call...');
      
      // Simulate API call with 3 second delay using axios timeout
      await new Promise((resolve) => setTimeout(resolve, 3000));
      
      console.log('Fake API call completed successfully');
    } catch (error) {
      console.error('Error in API call:', error);
    } finally {
      // Reset loading states
      setLoading(false);
      setIsLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Welcome to React Template App
      </Typography>
      
      {auth.user && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="h6">
            Hello, {auth.user.name || auth.user.email || 'User'}!
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            You are logged in successfully.
          </Typography>
        </Box>
      )}
      
      <Typography variant="body1" sx={{ mt: 3 }}>
        This is a protected home page that only authenticated users can access.
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Button 
          variant="contained" 
          onClick={fetchSampleData}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {loading ? 'Loading...' : 'Test API Loading'}
        </Button>
      </Box>
    </Paper>
  );
};

export default HomePage;